import { useTranslation } from 'react-i18next';
import type { KnowledgeDocumentStatus } from '../../../hooks/useKnowledgeDocuments';

const VARIANT: Record<KnowledgeDocumentStatus, string> = {
  uploaded: 'bg-slate-500/15 text-slate-600 dark:text-slate-300',
  processing: 'bg-amber-500/15 text-amber-700 dark:text-amber-300',
  ready: 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300',
  failed: 'bg-red-500/15 text-red-700 dark:text-red-300',
};

export default function KnowledgeStatusBadge({ status }: { status: KnowledgeDocumentStatus }) {
  const { t } = useTranslation();
  const label = t(`knowledge.status.${status}`, { defaultValue: status });
  return (
    <span
      className={`inline-flex rounded-md px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${VARIANT[status]}`}
    >
      {label}
    </span>
  );
}
